/**
 * Initialize context-aware theme selection
 * Automatically defaults to dark mode between Maghrib and Fajr
 */
export default defineNuxtPlugin(() => {
  if (process.client) {
    useContextAwareTheme();
  }
});
